
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("ember-scroll-modifiers/services/observer-manager", function(){ return i("ember-scroll-modifiers/services/observer-manager.js");});
d("ember/index", function(){ return i("ember-source/ember/index.js");});
import "@showbie/feature-flags-ember/-embroider-implicit-modules.js";
import "@ember/test-waiters/-embroider-implicit-modules.js";
import "@embroider/legacy-inspector-support/-embroider-implicit-modules.js";
import "@embroider/router/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-cli-mirage/-embroider-implicit-modules.js";
import "ember-click-outside-modifier/-embroider-implicit-modules.js";
import "ember-concurrency/-embroider-implicit-modules.js";
import "ember-css-transitions/-embroider-implicit-modules.js";
import "ember-focus-trap/-embroider-implicit-modules.js";
import "ember-keyboard/-embroider-implicit-modules.js";
import "ember-media-query/-embroider-implicit-modules.js";
import "ember-modifier/-embroider-implicit-modules.js";
import "ember-page-title/-embroider-implicit-modules.js";
import "ember-qunit/-embroider-implicit-modules.js";
import "ember-resources/-embroider-implicit-modules.js";
import "ember-router-helpers/-embroider-implicit-modules.js";
import "ember-shiki/-embroider-implicit-modules.js";
import "ember-simple-auth/-embroider-implicit-modules.js";
import "ember-sinon-qunit/-embroider-implicit-modules.js";
import "ember-stargate/-embroider-implicit-modules.js";
import "ember-truth-helpers/-embroider-implicit-modules.js";
import "ember-window-mock/-embroider-implicit-modules.js";
import "reactiveweb/-embroider-implicit-modules.js";
import "tracked-built-ins/-embroider-implicit-modules.js";
import "ember-cli-inject-live-reload/-embroider-implicit-modules.js";
import "@ember/optional-features/-embroider-implicit-modules.js";
import "@embroider/macros/-embroider-implicit-modules.js";
import "@ember/render-modifiers/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "@ember/test-helpers/-embroider-implicit-modules.js";
import "@glimmer/tracking/-embroider-implicit-modules.js";
import "ember-apollo-client/-embroider-implicit-modules.js";
import "ember-template-imports/-embroider-implicit-modules.js";
import "ember-cli-code-coverage/-embroider-implicit-modules.js";
import "@glimmer/component/-embroider-implicit-modules.js";
import "@percy/ember/-embroider-implicit-modules.js";
import "@sentry/ember/-embroider-implicit-modules.js";
import "@showbie/ember-cli-deploy-lambda-invoke/-embroider-implicit-modules.js";
import "ember-a11y-testing/-embroider-implicit-modules.js";
import "ember-cli-app-version/-embroider-implicit-modules.js";
import "ember-cli-clean-css/-embroider-implicit-modules.js";
import "ember-cli-dependency-checker/-embroider-implicit-modules.js";
import "ember-cli-deploy/-embroider-implicit-modules.js";
import "ember-cli-deploy-archive/-embroider-implicit-modules.js";
import "ember-cli-deploy-build/-embroider-implicit-modules.js";
import "ember-cli-deploy-display-revisions/-embroider-implicit-modules.js";
import "ember-cli-deploy-revision-data/-embroider-implicit-modules.js";
import "ember-cli-deploy-s3-index/-embroider-implicit-modules.js";
import "ember-cli-deploy-slack/-embroider-implicit-modules.js";
import "ember-test-selectors/-embroider-implicit-modules.js";
import "ember-cli-postcss/-embroider-implicit-modules.js";
import "broccoli-asset-rev/-embroider-implicit-modules.js";
import "ember-cli-terser/-embroider-implicit-modules.js";
import "ember-cli-sri/-embroider-implicit-modules.js";
import "ember-intl/-embroider-implicit-modules.js";
import "ember-load-initializers/-embroider-implicit-modules.js";
import "ember-resolver/-embroider-implicit-modules.js";
import "ember-scroll-modifiers/-embroider-implicit-modules.js";
import "ember-sinon/-embroider-implicit-modules.js";
import "ember-source/-embroider-implicit-modules.js";
import "ember-svg-jar/-embroider-implicit-modules.js";
import "loader.js/-embroider-implicit-modules.js";
import "test-fixtures/-embroider-implicit-modules.js";
